<template>
  <div class="year-months" :style="gridStyle">
    <span v-for="({ year, size }, key) of years" :key="key">{{ year }}</span>
  </div>
</template>

<script>
import { groupBy, sortBy } from 'lodash'

export default {
  name: 'YearLabels',
  props: {
    yearMonths: { type: Array, default: () => [] },
  },
  data() {
    return {}
  },
  computed: {
    years() {
      const years = this.yearMonths.map(yearMonth => yearMonth.split('/')[0])
      const grouped = Object.entries(groupBy(years)).map(([year, ary]) => ({ year: +year, size: ary.length }))
      return sortBy(grouped, ['year'])
    },
    gridStyle() {
      return {
        gridTemplateColumns: this.years.map(({ size }) => `${size}fr`).join(' '),
      }
    },
  },
  methods: {},
}
</script>

<style lang="postcss" scoped>
.year-months {
  box-sizing: border-box;
  display: grid;
  gap: 8px;
  grid-auto-flow: column;
  height: 16px;

  span {
    background-color: var(--light-gray);
    color: var(--white);
    font-size: 11px;
    font-weight: bold;
    text-align: center;

    &:first-child {
      margin-left: 8px;
    }
    &:last-child {
      margin-right: 8px;
    }
  }
}
</style>
